class MinerwaTestimonials extends HTMLElement {
  connectedCallback() {
    this.slots = [...this.querySelectorAll('.minerwa-voices__slot')];
    this.thumbs = [...this.querySelectorAll('[data-voice]')];
    this.stories = [...this.querySelectorAll('[data-story]')];
    this.roleChip = this.querySelector('[data-role-chip]');
    this.panel = this.querySelector('[data-voice-panel]');
    if (this.stories.length === 0) return;

    this.index = 0;
    this.paused = false;
    this.visible = false;
    this.unmutedId = null;
    this.intervalMs = (Number(this.dataset.interval) || 0) * 1000;

    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        this.muteAll();
        this.setIndex(Number(thumb.dataset.voice));
        this.restart();
      });
    });

    this.querySelectorAll('[data-voice-sound]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.stopPropagation();
        this.toggleSound(button.dataset.voiceSound);
      });
    });

    [...this.slots, this.panel].forEach((el) => {
      el?.addEventListener('mouseenter', () => { this.paused = true; });
      el?.addEventListener('mouseleave', () => { this.paused = false; });
    });

    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.visible = entry.isIntersecting;
        if (entry.isIntersecting) {
          this.start();
        } else {
          this.stop();
          this.muteAll();
        }
        this.syncPlayback();
      },
      { threshold: 0.2 },
    );
    this.observer.observe(this);

    this.setIndex(0);
  }

  disconnectedCallback() {
    this.stop();
    this.observer?.disconnect();
  }

  setIndex(index) {
    this.index = index;
    this.thumbs.forEach((t, i) => t.toggleAttribute('data-current', i === index));
    this.slots.forEach((s, i) => s.toggleAttribute('data-current', i === index));
    this.stories.forEach((s, i) => s.toggleAttribute('data-current', i === index));

    const role = this.stories[index]?.querySelector('.minerwa-voices__role')?.textContent ?? '';
    if (this.roleChip) this.roleChip.textContent = role;

    this.syncPlayback();
  }

  syncPlayback() {
    if (!this.visible) {
      this.videos().forEach((video) => video.pause());
      return;
    }

    this.videos().forEach((video) => {
      if (video.dataset.voiceVideo === String(this.index)) {
        if (video.preload !== 'auto') {
          video.preload = 'auto';
          video.load();
        }
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }

  videos() {
    return [...this.querySelectorAll('[data-voice-video]')];
  }

  videoFor(id) {
    return this.querySelector(`[data-voice-video="${id}"]`);
  }

  muteAll() {
    if (this.unmutedId === null) return;
    const video = this.videoFor(this.unmutedId);
    if (video) video.muted = true;
    this.slots[Number(this.unmutedId)]?.removeAttribute('data-unmuted');
    this.unmutedId = null;
  }

  toggleSound(id) {
    const video = this.videoFor(id);
    if (!video) return;

    if (this.unmutedId === id) {
      this.muteAll();
      return;
    }

    this.muteAll();
    video.muted = false;
    if (video.preload !== 'auto') {
      video.preload = 'auto';
      video.load();
    }
    video.play().catch(() => {});
    this.slots[Number(id)]?.setAttribute('data-unmuted', '');
    this.unmutedId = id;
  }

  start() {
    if (this.timer || !this.intervalMs) return;
    this.timer = setInterval(() => {
      if (this.paused || this.unmutedId !== null) return;
      this.setIndex((this.index + 1) % this.stories.length);
    }, this.intervalMs);
  }

  stop() {
    clearInterval(this.timer);
    this.timer = null;
  }

  restart() {
    this.stop();
    this.start();
  }
}

if (!customElements.get('minerwa-testimonials')) {
  customElements.define('minerwa-testimonials', MinerwaTestimonials);
}
